import { PropertyMapper } from '../../decorators';

export class InternalActivityType {

    @PropertyMapper({ jsonProperty: 'id' })
    public id: number;

    @PropertyMapper({ jsonProperty: 'name' })
    public name: string;

}
